"use client";
import { createElement, forwardRef, type HTMLAttributes } from "react";
import { Slot } from "@radix-ui/react-slot";
export type SurfaceProps = HTMLAttributes<HTMLElement> & {
  as?: "div" | "section" | "article" | "aside";
  asChild?: boolean;
  tone?: "surface" | "sage" | "accent" | "inverse";
};
export const Surface = forwardRef<HTMLElement, SurfaceProps>(function Surface(
  { as = "div", asChild, tone = "surface", className = "", ...props },
  ref,
) {
  return createElement(asChild ? Slot : as, {
    ...props,
    ref,
    className: `dx-surface dx-surface--${tone} ${className}`,
  });
});
export const Card = Surface;
export function Container({
  wide = false,
  className = "",
  ...props
}: HTMLAttributes<HTMLDivElement> & { wide?: boolean }) {
  return (
    <div
      {...props}
      className={`dx-container ${wide ? "dx-container--wide" : ""} ${className}`}
    />
  );
}
